export function parseAmount(raw: string): number | undefined {
    if (raw.trim() === '') {
        return undefined;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : undefined;
}
